import React from 'react'

const CustomButton = ({type='button', text, onClick, variant = 'primary', className = '', icon ,disabled=false ,loading=false}) => {
    const variants = {
      primary: 'bg-brand-500  hover:bg-brand-600',
      success: 'bg-[#166534] hover:bg-[#15803d]',
      purple: 'bg-[#5b21b6] hover:bg-[#7c3aed]',
      blue: 'bg-blue-600 hover:bg-blue-700',
      light: 'bg-blue-100 hover:bg-blue-200 text-blue-700',
      cancel:'bg-red-400 hover:bg-red-500',
      building:'bg-[#1a365d] hover:bg-[#2d4a7c]'
    };
  return (
    <button
    disabled={disabled || loading}
    type={type}
    className={`flex items-center gap-2 ${variants[variant]} text-white px-3.5 py-2 text-sm font-medium rounded-lg shadow-sm transition-colors justify-center ${className}  ${disabled || loading ? "cursor-not-allowed opacity-50" : ""}`}
    onClick={onClick}
  >
     {icon && icon}
     {loading ? (
        <div className="flex items-center justify-center">
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
              Processing...
            </div>
      ) : (
        text
      )}
  </button>
  )
}

export default CustomButton
